import undoable, {includeAction} from 'redux-undo';
import * as UndoableConstants from '~/constants/Undoable';

export function makeUndoable(reducer) {
  return undoable(reducer, {
    filter: action => {
      // Check if the action has redoUndoable set to false in its meta
      if (action.meta && action.meta.redoUndoable === false) {
        return false; // Don't include this action in undo history
      }
      // Use the standard includeAction filter for all other actions
      return includeAction(UndoableConstants.TYPES)(action);
    },
    limit: UndoableConstants.LIMIT
  });
}
